<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import InboxesAPI from 'dashboard/api/inboxes';

export default {
  components: { PageHeader, NextButton },
  data() {
    return {
      inboxName: '',
      apiKey: '',
      channelId: '',
      channels: [],
      channelsLoaded: false,
      isLoadingChannels: false,
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  methods: {
    resetChannels() {
      this.channelId = '';
      this.channels = [];
      this.channelsLoaded = false;
    },
    channelLabel(channel) {
      const transport = channel.transport === 'wapi' ? 'WABA' : 'WhatsApp';
      const state = channel.active
        ? 'активен'
        : `недоступен: ${channel.state || 'неизвестно'}`;
      return `${channel.plain_id || 'Без номера'} · ${transport} · ${state}`;
    },
    async loadChannels() {
      if (!this.apiKey.trim()) {
        useAlert('Введите API-ключ Wazzup24');
        return;
      }

      this.isLoadingChannels = true;
      this.channelId = '';
      try {
        const { data } = await InboxesAPI.getWazzupChannels(this.apiKey.trim());
        this.channels = data.channels || [];
        this.channelsLoaded = true;

        const activeChannels = this.channels.filter(channel => channel.active);
        if (activeChannels.length === 1) this.channelId = activeChannels[0].id;
        if (!activeChannels.length) {
          useAlert('Активные каналы WhatsApp/WABA не найдены');
        }
      } catch (error) {
        this.channels = [];
        this.channelsLoaded = false;
        useAlert(
          error?.response?.data?.error || 'Не удалось получить каналы Wazzup24'
        );
      } finally {
        this.isLoadingChannels = false;
      }
    },
    async createChannel() {
      if (!this.inboxName.trim() || !this.apiKey || !this.channelId) {
        useAlert('Заполните название, API-ключ и channelId Wazzup24');
        return;
      }
      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName.trim(),
          channel: {
            type: 'wazzup',
            provider_config: {
              api_key: this.apiKey,
              channel_id: this.channelId,
            },
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: inbox.id },
        });
      } catch (error) {
        useAlert(
          error?.response?.data?.message ||
            'Не удалось создать источник Wazzup24'
        );
      }
    },
  },
};
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/html-closing-bracket-newline -->
<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader
      header-title="WhatsApp через Wazzup24"
      header-content="WhatsApp-источник через агрегатор Wazzup24 (отправка/приём)."
    />
    <form class="flex flex-col flex-wrap mx-0" @submit.prevent="createChannel">
      <div class="flex-shrink-0 flex-grow-0">
        <label
          >Название канала в MedUp Chat<input
            v-model="inboxName"
            type="text"
            placeholder="Например: WhatsApp ДВ-Химки"
        /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label
          >API-ключ Wazzup24<input
            v-model="apiKey"
            type="password"
            autocomplete="off"
            @input="resetChannels"
        /></label>
      </div>
      <div class="w-full mt-2 mb-4">
        <NextButton
          :is-loading="isLoadingChannels"
          :disabled="!apiKey.trim()"
          type="button"
          outline
          blue
          label="Загрузить каналы из Wazzup"
          @click="loadChannels"
        />
      </div>
      <div v-if="channelsLoaded" class="flex-shrink-0 flex-grow-0">
        <label>
          Канал WhatsApp из Wazzup
          <select v-model="channelId">
            <option value="" disabled>Выберите канал</option>
            <option
              v-for="channel in channels"
              :key="channel.id"
              :value="channel.id"
              :disabled="!channel.active"
            >
              {{ channelLabel(channel) }}
            </option>
          </select>
        </label>
      </div>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          label="Создать источник"
        />
      </div>
    </form>
  </div>
</template>
